import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { fg } from '@confluence/feature-gating';
import {
	ADMIN_CONFIGURATION,
	ADMIN_STORAGE_MANAGEMENT,
} from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { StorageManagementPageLoader } from '@confluence/storage-management/entry-points/StorageManagementPage.ts';

export const AdminStorageManagementRoute: {
	(): React.JSX.Element;
	ROUTE_NAME: string;
	NAVIGATION_PARAMS(): {
		Screen: { screenEvent: { name: string } };
		MainLayout: { navView: string };
	};
} = (): React.JSX.Element => {
	if (!fg('confluence_storage_management_page')) {
		return <Redirection name={ADMIN_CONFIGURATION.name} />;
	}

	return <StorageManagementPageLoader />;
};

AdminStorageManagementRoute.ROUTE_NAME = ADMIN_STORAGE_MANAGEMENT.name;

AdminStorageManagementRoute.NAVIGATION_PARAMS = () => {
	return {
		Screen: {
			screenEvent: { name: 'adminStorageManagementScreen' },
		},
		MainLayout: {
			navView: ADMIN_HOME_ID,
		},
	};
};
